import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAccessManagementSearchParams } from "@/hooks"
export const deleteUser = async (userId: string) => {
  const url = `${ENDPOINTS.USERS}/${userId}`
  const { data } = await api.delete<UserResponseType>(url)
  return data
}
const useAccessManagementDelete = () => {
  const queryClient = useQueryClient()
  const searchParams = useAccessManagementSearchParams()
  const deleteUserMutation = useMutation({
    mutationFn: (userId: string) => deleteUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`${ENDPOINTS.USERS}/${searchParams}`, searchParams],
      })
    },
  })
  return {
    ...queryClient,
    deleteUserMutation,
  }
}
export default useAccessManagementDelete
